import styled from "styled-components";

import { useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";

import User from "../types/User";
import FlexBox, { FlexBoxProps, FlexGrow } from "./FlexBox";
import Status from "../types/enum/Status";
import Breadcrumb from "./Breadcrumb";
import useDebounce from "./use-debounce";
import Input, { InputContainer, InputIconContainer } from "./Input";
import Icon from "./Icon";
import { UserContext } from "../context/UserContext";
import Button from "./Button";
import { SemesterContext } from "../context/SemesterContext";

const StyledNavbar = styled(FlexBox)<{ isMobile?: boolean } & FlexBoxProps>`
  // background-color: #0c0d22;
  // box-shadow: ${({ theme }) => theme.shadow(8, Status.default)};
  // z-index: 100;

  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 24px;
`;

const CloseIcon = styled("span")`
  position: absolute;
  right: 60px;
  top: 12px;
  cursor: pointer;
`;

export type NavbarProps = {
  breadcrumb: Array<{
    name: string;
    link?: string;
  }>;
  user?: User;
  onSidebarToggle?: (arg0: unknown) => void;
  searchCompetency?: (search: string) => void;
  clearSearch: () => void;
  showSignout?: boolean;
};

function CompetencyNavbar({
  breadcrumb,
  searchCompetency,
  clearSearch,
}: NavbarProps): JSX.Element {
  const screenClass = useScreenClass();

  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearchTerm = useDebounce(searchValue, 300);
  const userContext = useContext(UserContext);
  const semesterContext = useContext(SemesterContext);

  const handleSearchChange = (text: string) => {
    setSearchValue(text);
  };
  // useEffect(() => {
  //   if (debouncedSearchTerm) {
  //     searchCompetency?.(searchValue);
  //     userContext.setSearchView(true);
  //   } else {
  //     searchCompetency?.("");
  //     userContext.setSearchView(false);
  //   }
  // }, [semesterContext]);
  return (
    <>
      <StyledNavbar space={5} isMobile={isMobile}>
        <FlexBox style={{ flexBasis: "100%" }}>
          <FlexGrow>
            {!userContext.searchView && <Breadcrumb path={breadcrumb} />}
          </FlexGrow>
          <FlexGrow>
            <InputContainer
              as="form"
              onSubmit={() => {}}
              style={{ width: "100%" }}
            >
              {/* <InputIconContainer style={{ left: '8px', right: 'unset' }} onClick={(e: any) => e.preventDefault()}>
                <Icon size={2.5} name="search" status={Status.default} />
              </InputIconContainer> */}
              <Input
                id="search-input"
                name="searchInput"
                // eslint-disable-next-line max-len
                // onKeyPress={(event) =>
                //   ["\\", "[", "]"].includes(event.key) && event.preventDefault()
                // }
                // eslint-disable-next-line max-len
                onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleSearchChange(e.target.value)
                }
                placeholder="Search competencies..."
                value={searchValue}
                style={{
                  width: "inherit",
                  color: "white",
                  padding: "10px 20px",
                }}
              />
              {searchValue !== "" && (
                <CloseIcon
                  title="Clear Search"
                  onClick={(e: any) => {
                    e.preventDefault();
                    setSearchValue("");
                    clearSearch();
                    userContext.setSearchView(false);
                  }}
                >
                  <Icon size={3} name="times" status={Status.default} />
                </CloseIcon>
              )}
              <InputIconContainer
                title="Search"
                style={{
                  width: "40px",
                  height: "40px",
                  border: "1px solid transparent",
                  backgroundColor: "#8a4041",
                  // top: "3px",
                  // bottom: "6px",
                  color: "white",
                }}
                onClick={(e: any) => {
                  e.preventDefault();
                  // setSearchValue("");
                  searchCompetency?.(searchValue);
                }}
                disabled={searchValue === ""}
              >
                <Icon size={2.5} name="search" status={Status.default} />
              </InputIconContainer>
            </InputContainer>
          </FlexGrow>
        </FlexBox>
      </StyledNavbar>
    </>
  );
}

export default CompetencyNavbar;
